import { tallyTokens } from "../../theme.tsx";
import React from "react";
import { Card, CardActionArea, CardContent } from "@mui/material";

interface TileCardProps {
  onClick: () => void;
  children: React.ReactNode;
}

const TileCard: React.FC<TileCardProps> = ({ onClick, children }) => (
  <Card
    variant="outlined"
    sx={{
      width: "100%",
      display: "flex",
      minHeight: { xs: 106, lg: 86 },
      borderRadius: `${tallyTokens.radius.lg}px`,
      border: "1px solid",
      borderColor: tallyTokens.line,
      backgroundColor: tallyTokens.surface,
      boxShadow: tallyTokens.shadow.sm,
      transition: "box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out",
      "&:hover": {
        boxShadow: tallyTokens.shadow.md,
        borderColor: tallyTokens.lineStrong,
      },
    }}
  >
    <CardActionArea onClick={onClick} sx={{ p: 2, flexGrow: 1 }}>
      <CardContent sx={{ p: "0 !important" }}>{children}</CardContent>
    </CardActionArea>
  </Card>
);

export default TileCard;
